import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_repo = _resolveComponent("repo")!
  const _component_border_section = _resolveComponent("border-section")!

  return (_openBlock(), _createBlock(_component_border_section, { header: _ctx.header }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repos, (repo, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["pt-5 is-flex is-flex-direction-column is-align-items-center has-background-light", {'has-background-white-bis': !(index % 2)}]),
            key: repo.nameWithOwner
          }, [
            _createVNode(_component_repo, {
              repo: repo,
              pulls: _ctx.reposToPulls[repo.nameWithOwner]
            }, null, 8, ["repo", "pulls"])
          ], 2))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["header"]))
}